import React from "react";
import {
  withStyles,
  List,
  ListItem,
  ListSubheader,
  IconButton,
  Button,
} from "@material-ui/core";
import {
  getImagesFromBlobStorage,
  STOP_IMAGES,
  PRO_IMAGES,
} from "./getBlobImages";
import {
  ProImagesTabPanel,
  StopImagesTabPanel,
  LoadingView,
} from "./TabPanels";
import { withUserProfile } from "../../../../../../userProfile/userProfileContext";
import { compose } from "recompose";
import CloseIcon from "@material-ui/icons/Close";
import { RMAXLogger } from "../../../../../../services/LoggerService/RMAXLogger";
import { getDataWithQueryString } from "../../../../../../api/componentAPIs";
import { Refresh } from "@material-ui/icons";
import StyledSelect from "../../../../../common/StyledSelect";
import {
  base64toBlob,
  getProImagesCount,
  getStopsList,
  getTerminalTimeFromTimestamp,
  getAddressFromReverseGeocodingResults,
  getImageDetailsFromImageURLs,
  shouldFetchStopImagesOnStopChange,
} from "./utils";
import IBplanningProImages from "./IBPlanningProImages";
import { getProNumbers } from "../utils";
import { isEqual } from "lodash/lang";
import { FILE_TYPES } from "../../../../../common/ProImages/components/utils/blobUtils";
import styles from "./stopImageStyles";
import { ReverseGeocodingBatch } from "../../../../../../lib/Map/Trimble";
import { formatAddress } from "../../../utils/utils";
import ImageAddress from "../../../../../common/ProImages/components/Popup/components/ImageAddress";
import WithDialog from "./WithDialog";
import DeliveryReceiptList from "./DeliveryReceiptList";
import { withAppConfig } from "@appConfigContext";
class StopImagesDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      proImages: "",
      stopImages: "",
      showImages: this.props.showImages,
      imageURLDetailsByTimestamp: {},
      fetchError: false,
      imageURLData: {},
      loading: true,
      stopId: "",
      stopsList: [],
      eDRData: {},
      adnData: {}
    };
  }

  componentDidMount() {
    if (this.props.stopId) {
      this.setState({
        stopId: this.props.stopId,
        stopsList: getStopsList(this.props.stops),
        proNumbers: this.props.proNumbers.length
          ? this.props.proNumbers
          : this.getSelectedStopProNumbers(this.props.stopId),
        ...(!this.props.isStopCompleted && { loading: false })
      });
      const isADNRequired = this.props.configJSON.enableAdvanceDeliveryNotificationInDispatch && this.getSelectedStopIsADNRequired(this.props.stopId);
      if (this.props.isStopCompleted || isADNRequired) {
      this.getImageData(this.props.stopId);
      }
    }
    RMAXLogger.info("ViewStopImages", {
      terminalCode: this.props.terminalCode,
      routeId: this.props.routeId,
      stopId: this.props.stopId,
      eventDateTime: new Date(),
    });
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.stops, this.props.stops)) {
      this.setState({
        stopsList: getStopsList(this.props.stops),
      });
    }
  }

  getSelectedStopProNumbers = (stopId) => {
    const stopData = this.props.stops.find(
      (stop) => stop.stopId === stopId
    );
    return stopData ? getProNumbers(stopData.shipments) : [];
  }

  getSelectedStopIsADNRequired = (stopId) => {
    if (!this.props.configJSON.enableAdvanceDeliveryNotificationInDispatch) return false;
    const stopData = this.props.stops.find(
      (stop) => stop.stopId === stopId
    );
    return stopData ? stopData.isADNRequired : false;
  }

  getImageData = (stopId) => {
    getDataWithQueryString(
      `${this.props.apiName}`,
      `terminalCode=${this.props.terminalCode}&stopId=${stopId}&routeId=${this.props.routeId}`
    ).then(
      (response) => {
        if (response && response.status >= 200 && response.status < 400) {
          this.setState({
            imageURLData: response.data,
            fetchError: false,
          });
          this.setImageLocationDetails(response.data);
          this.fetchBlobImages(response.data);
        } else {
          this.handleError();
        }
      },
      (_error) => {
        this.handleError();
      }
    );
  };

  hideLoader = () => {
    this.setState({
      loading: false,
    });
  };

  setImageLocationDetails = async (imageData) => {
    const imageURLDetailsByTimestamp = {};
    const terminalOffset = this.props.userData.userProfile.terminal.offset;
    const imageURLDetailsList = getImageDetailsFromImageURLs(imageData);
    const reverseGeoCodedLocations = await ReverseGeocodingBatch(
      imageURLDetailsList.filter((location) => (location.latitude && location.longitude))
    );
    imageURLDetailsList.forEach((imageURLParams) => {
      const { timestamp, latitude, longitude, file } = imageURLParams;
      const addressDetails =
        getAddressFromReverseGeocodingResults({
          latitude,
          longitude,
          reverseGeoCodedLocations
        }) ?? null;
      let address = '';
      if (addressDetails) {
        const {
          Address: { StreetAddress, City, State, Zip, County }
        } = addressDetails;
        address = formatAddress({
          address: StreetAddress,
          address2: City,
          city: County,
          state: State,
          zip: Zip
        });
      }

      const { date, time } = getTerminalTimeFromTimestamp(+timestamp, terminalOffset);
      imageURLDetailsByTimestamp[timestamp] = {
        address,
        date,
        time,
        latitude,
        longitude,
        file
      };
    });
    this.setState({
      imageURLDetailsByTimestamp,
    });
  };

  fetchBlobImages = (imageData) => {
    const { showImages, proImages, stopImages, eDRData } = this.state;
    if (this.state.proNumbers?.includes(showImages)) {
      const proData = imageData?.pros?.find((pro) => pro.proId === showImages);
      !proImages[showImages]
        ? getImagesFromBlobStorage({
          folderName: showImages,
          updateFunction: this.setProImages,
          handleError: this.handleError,
          imageData: proData?.proImages ?? {},
          fileType: FILE_TYPES.IMAGE,
        })
        : this.hideLoader();
      if (!eDRData[showImages] && proData?.eDR) {
        getImagesFromBlobStorage({
          folderName: showImages,
          updateFunction: this.setEDR,
          handleError: this.handleError,
          imageData: { eDR: [...proData?.eDR] },
          fileType: FILE_TYPES.PDF,
        });
      }
      if (!proImages[showImages] && proData?.adn) {
        getImagesFromBlobStorage({
          folderName: showImages,
          updateFunction: this.setADN,
          handleError: this.handleError,
          imageData: { adn: [...proData?.adn] },
          fileType: FILE_TYPES.PDF,
        });
      }
      return;
    }
    !stopImages[showImages]
      ? getImagesFromBlobStorage({
        folderName: showImages,
        imageData: {
          [showImages]: imageData?.stopImages?.[showImages] ?? [],
        },
        updateFunction: this.setStopImage,
        handleError: this.handleError,
        fileType: FILE_TYPES.IMAGE,
      })
      : this.hideLoader();
  };

  setProImages = (proNumber, value) => {
    this.setState((state) => ({
      ...state,
      loading: false,
      proImages: {
        ...(state.proImages ?? {}),
        [proNumber]: value,
      },
    }));
  };

  setEDR = (proNumber, value) => {
    this.setState((state) => ({
      ...state,
      loading: false,
      eDRData: {
        ...(state.eDRData ?? {}),
        [proNumber]: value,
      },
    }));
  };

  setADN = (proNumber, value) => {
    this.setState((state) => ({
      ...state,
      loading: false,
      adnData: {
        ...(state.adnData ?? {}),
        [proNumber]: value,
      },
    }));
  };

  setStopImage = (stopId, value) => {
    this.setState((state) => ({
      ...state,
      loading: false,
      stopImages: {
        ...state.stopImages,
        ...value,
      },
    }));
  };

  showImages = (event) => {
    const showImages = event.target.getAttribute("data-value");
    if (showImages && showImages !== this.state.showImages) {
      this.setState({ showImages, loading: true, fetchError: false }, () =>
        this.fetchBlobImages(this.state.imageURLData)
      );
    }
  };

  getStopImagesList = () => {
    // Updates the stop images list which are not listed in STOP_IMAGES
    const stopImagesKeys = Object.keys(STOP_IMAGES);
    const additionalStopImages = Object.keys(
      this.state.imageURLData?.stopImages || {}
    ).reduce((stopImage, stopImageKey) => {
      if (!stopImagesKeys.includes(stopImageKey)) {
        stopImage[stopImageKey] = stopImageKey;
      }
      return stopImage;
    }, {});

    return {
      ...STOP_IMAGES,
      ...additionalStopImages,
    };
  };

  refreshImageData = () => {
    this.props.refreshDriverRouteData?.();
    const isStopCompleted = this.props.stops.find(
      (stop) => stop.stopId.toLowerCase() === this.state.stopId?.toLowerCase()
    )?.isStopCompleted;
    const isADNRequired = this.getSelectedStopIsADNRequired(this.state.stopId);
    if (isStopCompleted || isADNRequired) {
      this.setState({
        fetchError: false,
        proImages: "",
        stopImages: "",
        loading: true,
        imageURLData: {}
      });
      this.getImageData(this.state.stopId);
    }
  };

  handleError = () => {
    this.setState({
      loading: false,
      fetchError: true,
    });
  };

  handleStopChange = (value) => {
    const { stopsList } = this.state;
    const stopId = value?.value || stopsList?.[0]?.value || "";
    const isStopCompleted = value?.isStopCompleted ?? stopsList?.[0]?.isStopCompleted ?? false;
    const isADNRequired = this.getSelectedStopIsADNRequired(stopId);

    if (!stopId) {
      this.setState({ stopId: "" });
      return;
    }

    if (stopId === this.state.stopId) return;

    const proNumbers = this.getSelectedStopProNumbers(stopId);
    this.setState(
      {
        stopId,
        fetchError: false,
        proNumbers,
        proImages: "",
        stopImages: "",
        imageURLData: {},
        loading: isStopCompleted,
        showImages: proNumbers[0] || Object.keys(STOP_IMAGES)[0],
        eDRData: {},
        adnData: {},
      },
      () =>
        shouldFetchStopImagesOnStopChange(isStopCompleted, isADNRequired) &&
        this.getImageData(stopId)
    );
  };

  openEDR = (eDR) => {
    const blob = base64toBlob(eDR?.blobData);
    const fileURL = URL.createObjectURL(blob);
    window.open(fileURL);
  };

  getStopFullAddressById = (stopId) => {
    const stopData = this.props.stops.find((stop) => stop.stopId === stopId) || null;
    return formatAddress({
      address: stopData?.address,
      address2: stopData?.address2,
      city: stopData?.city,
      state: stopData?.state,
      zip: stopData?.zip
    });
  };

  getReceiverData = (stopId, proId) => {
    if (this.props.enablePublishDeliveryReceiptFromReport) {
      const stopData = this.props.stops.find((stop) => stop.stopId === stopId);
      if (stopData) {
        const proData = stopData.shipments.find((shipment) => shipment.proId === proId);
        return proData?.receiverDetails
          ? {
            ...proData?.receiverDetails,
            terminalCode: this.props.terminalCode,
            routeId: this.props.routeId
          }
          : null;
      }
    }
    return null;
  };

  render() {
    const {
      proImages,
      stopImages,
      showImages,
      fetchError,
      proNumbers,
      stopsList,
      imageURLData,
      stopId,
      eDRData,
      imageURLDetailsByTimestamp,
      adnData
    } = this.state;
    const {
      classes,
      hideHeaderActions = false,
      enablePublishDeliveryReceiptFromReport = false
    } = this.props;
    const stopImagesList = this.getStopImagesList();
    const stopAddress = this.getStopFullAddressById(stopId);
    const proReceiverDetails = this.getReceiverData(stopId, showImages);

    return (
      <>
        <div className={classes.closeButtonContainer}>
          <div className={classes.dropDownContainer}>
            <span className={classes.headerText}>Stop Images</span>
            {!hideHeaderActions && <div>
              {stopId && <StyledSelect
                data={stopsList}
                textFieldProps={{
                  id: "stop",
                  variant: "outlined",
                  label: "",
                }}
                onChange={this.handleStopChange}
                value={stopId}
                isNotClearable
                InputPropsClasses={{
                  input: classes.dropdownInput,
                }}
                isDisabled={hideHeaderActions}
              />}
              {stopAddress && (
                <ImageAddress address={stopAddress} />
              )}
            </div>}
          </div>
          {!hideHeaderActions && <div>
            {stopId && <Button
              variant="outlined"
              color="primary"
              onClick={this.refreshImageData}
              className={classes.refreshButton}
            >
              <Refresh /> <span>Refresh</span>
            </Button>}
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={this.props.close}
            >
              <CloseIcon />
            </IconButton>
          </div>}
        </div>
        <div className={classes.dialogContent}>
          {!stopId ? (
            <div className={`${classes.center} ${classes.message}`}>
              Not Available
            </div>
          ) : (
            <>
              <div>
                <List onClick={this.showImages}>
                  <ListSubheader className={classes.listSubHeader}>
                    Pro Images
                  </ListSubheader>
                  {proNumbers.map((proNumber) => {
                    const proImagesCount = getProImagesCount(proNumber, imageURLData?.pros)
                    return (
                      <ListItem
                        key={proNumber}
                        classes={{
                          root: classes.listItem,
                          selected: classes.listItemSelected,
                        }}
                        data-value={proNumber}
                        selected={showImages === proNumber}
                      >
                        {proNumber}
                        <span>({proImagesCount || 0})</span>
                      </ListItem>
                    );
                  })}
                  <br /> <br /> <br />
                  <ListSubheader className={classes.listSubHeader}>
                    Stop Images
                  </ListSubheader>
                  {Object.keys(stopImagesList).map((imageNameKey) => {
                    const stopImagesCount = imageURLData?.stopImages?.[imageNameKey]?.length
                    return (
                      <ListItem
                        key={imageNameKey}
                        classes={{
                          root: classes.listItem,
                          selected: classes.listItemSelected,
                        }}
                        data-value={imageNameKey}
                        selected={showImages === imageNameKey}
                      >
                        {stopImagesList[imageNameKey]}
                        {stopImagesCount && <span>({stopImagesCount}) </span>}
                      </ListItem>
                    );
                  })}
                </List>
              </div>
              <div className={classes.imagesContainer}>
                <div className={`${classes.imageContainer} customScroll`}>
                  {this.state.loading && (
                    <LoadingView
                      label="Loading Images"
                      labelClass={classes.loadingLabel}
                    />
                  )}
                  {proNumbers.includes(showImages) && eDRData?.[showImages]?.eDR?.length > 0 ? (
                    <DeliveryReceiptList
                      items={eDRData[showImages].eDR}
                      label={PRO_IMAGES.edr}
                      classes={classes}
                      openEDR={this.openEDR}
                      imageURLDetailsByTimestamp={imageURLDetailsByTimestamp}
                      proReceiverDetails={proReceiverDetails}
                      enablePublishDeliveryReceiptFromReport={
                        enablePublishDeliveryReceiptFromReport
                      }
                    />
                  ) : null}
                  {proNumbers.includes(showImages) && adnData?.[showImages]?.adn?.length > 0 ? (
                    <DeliveryReceiptList
                      items={adnData[showImages].adn}
                      label={PRO_IMAGES.adn}
                      classes={classes}
                      openEDR={this.openEDR}
                      imageURLDetailsByTimestamp={imageURLDetailsByTimestamp}
                      proReceiverDetails={proReceiverDetails}
                      enablePublishDeliveryReceiptFromReport={
                        enablePublishDeliveryReceiptFromReport
                      }
                    />
                  ) : null}
                  {fetchError && (
                    <div className={`${classes.center} ${classes.error}`}>
                      Error while fetching images
                    </div>
                  )}
                  {!this.state.loading && !fetchError && (
                    <>
                      {stopImages && !proImages[showImages] ? (
                        <StopImagesTabPanel
                          label={stopImagesList[showImages]}
                          stopImages={stopImages[showImages]}
                          imageURLDetailsByTimestamp={imageURLDetailsByTimestamp}
                        />
                      ) : null}

                      {proImages && proImages[showImages] ? (
                        <ProImagesTabPanel
                          proImages={proImages[showImages]}
                          imageURLDetailsByTimestamp={imageURLDetailsByTimestamp}
                        />
                      ) : null}
                    </>
                  )}
                  {proNumbers.includes(showImages) ? (
                    <IBplanningProImages proNumber={showImages} />
                  ) : null}
                </div>
              </div>
            </>
          )}
        </div>
      </>
    );
  }
}

export default compose(
  withUserProfile,
  withStyles(styles),
  WithDialog,
  withAppConfig
)(StopImagesDialog);
